import React from 'react';
import clsx from 'clsx';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { TransitionProps } from '@mui/material/transitions';
import Fade from '@mui/material/Fade';
import './index.scss';

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
  ) => {
    return <Fade ref={ref} {...props} timeout={150} />;
  }
);

interface ModalProps {
  open: boolean;
  title?: React.ReactNode;
  content?: React.ReactNode;
  action?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  disableEscape?: boolean;
  disableBackDrop?: boolean;
  transitionComponent?: any;
  keepMounted?: boolean;
  containerClassName?: string;
  paperClassName?: string;
  titleClassName?: string;
  contentClassName?: string;
  actionClassName?: string;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({
  open,
  title,
  content,
  action,
  maxWidth,
  disableEscape,
  disableBackDrop,
  transitionComponent,
  keepMounted,
  containerClassName,
  paperClassName,
  titleClassName,
  contentClassName,
  actionClassName,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (disableBackDrop && reason && reason == 'backdropClick') return;
        onClose();
      }}
      maxWidth={maxWidth || 'md'}
      fullWidth
      classes={{
        root: 'd-dialog-root',
        container: clsx(containerClassName),
        paper: clsx('modal-paper', paperClassName),
      }}
      slots={{
        transition: transitionComponent || Transition,
      }}
      keepMounted={keepMounted}
      disableEscapeKeyDown={!!disableEscape}
    >
      {title && (
        <DialogTitle className={clsx('d-dialog-title', titleClassName)}>{title}</DialogTitle>
      )}
      {content && (
        <DialogContent className={clsx('d-dialog-content', contentClassName)}>
          {content}
        </DialogContent>
      )}
      {action && (
        <DialogActions className={clsx('d-dialog-action', actionClassName)}>{action}</DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
